import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import ProductShowcase from "../../components/cultivars/GastroPop/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const GastroPop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Gastro Pop - Premium Cannabis Cultivar | BeyondBloom™</title>
        <meta
          name="description"
          content="Explore Gastro Pop, a premium cannabis cultivar with bold flavors and a balanced high. Ideal for relaxation and uplifting effects."
        />
        <meta
          name="keywords"
          content="Gastro Pop, cannabis, premium cultivar, BeyondBloom, hybrid strain, bold flavors, top cannabis strains"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Gastro Pop - Premium Cannabis Cultivar | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Explore Gastro Pop, a premium cannabis cultivar with bold flavors and a balanced high. Ideal for relaxation and uplifting effects."
        />
        <meta property="og:image" content="/images/gastro-pop.png" />
        <meta property="og:url" content="https://yourwebsite.com/gastro-pop" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Gastro Pop - Premium Cannabis Cultivar | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Explore Gastro Pop, a premium cannabis cultivar with bold flavors and a balanced high. Ideal for relaxation and uplifting effects."
        />
        <meta name="twitter:image" content="/images/gastro-pop.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default GastroPop;
